import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, FormGroup, Input, Label, Button, Form, Alert } from "reactstrap";
import { get, put } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import Loader from "common/loader";
import { GET_EXPRESS_DELIVERY_SETTINGS, UPDATE_EXPRESS_DELIVERY_SETTINGS } from "helpers/api_endpoints";


//meta title
document.title = "Express Delivery Settings";

const ExpressDeliverySettings = () => {
    const [loading, setLoading] = useState(true);
    const [id, setid] = useState('1');
    const [initZoneDiameterValue, setInitZoneDiameterValue] = useState('');
    const [initZoneDiameterUnit, setInitZoneDiameterUnit] = useState('');
    const [zoneDiameterIncrementValue, setZoneDiameterIncrementValue] = useState('');
    const [zoneDiameterIncrementUnit, setZoneDiameterIncrementUnit] = useState('');
    const [maxZoneDiameterValue, setMaxZoneDiameterValue] = useState('');
    const [maxZoneDiameterUnit, setMaxZoneDiameterUnit] = useState('');
    const [maxAssigningTime, setMaxAssigningTime] = useState('');
    const [instantAssign, setInstantAssign] = useState(0);
    const [successMsg, setsuccessMsg] = useState('');
    const [errorMsg, seterrorMsg] = useState('');

    useEffect(() => {
        get(GET_EXPRESS_DELIVERY_SETTINGS)
            .then(response => {
                const data = response.data;
                setid(data.id);
                setInitZoneDiameterValue(data.initZoneDiameterValue);
                setInitZoneDiameterUnit(data.initZoneDiameterUnit);
                setZoneDiameterIncrementValue(data.zoneDiameterIncrementValue);
                setZoneDiameterIncrementUnit(data.zoneDiameterIncrementUnit);
                setMaxZoneDiameterValue(data.maxZoneDiameterValue);
                setMaxZoneDiameterUnit(data.maxZoneDiameterUnit);
                setMaxAssigningTime(data.maxAssigningTime);
                setInstantAssign(data.instantAssign);
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
            })
    }, []);

    useEffect(() => {
        if(initZoneDiameterValue > maxZoneDiameterValue)
        {
            seterrorMsg('Max Zone Diameter must be greater than or equal to Initial Zone Diameter');
            setMaxZoneDiameterValue(initZoneDiameterValue);
        }
        setTimeout(()=>{
            seterrorMsg('');
        },1700);
}, [initZoneDiameterValue, maxZoneDiameterValue]);

    const handleSubmit = () => {
        put(UPDATE_EXPRESS_DELIVERY_SETTINGS, { id, initZoneDiameterValue, initZoneDiameterUnit, 
            zoneDiameterIncrementValue, zoneDiameterIncrementUnit, maxZoneDiameterValue, maxZoneDiameterUnit, maxAssigningTime, instantAssign })
            .then(response => {
                if (response.code == 200) {
                    setsuccessMsg("Updated Successfully");
                    setTimeout(() => {
                        setsuccessMsg('');
                    }, 3000)
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Application" breadcrumbItem="Express Delivery Settings" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {successMsg ? <Alert style={{ margin: "5px" }} color="success">{successMsg}</Alert> : null}
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                                                <div className="form-group col-md-6 mt-2">
                                                    <Label className="form-label"><Trans>Initial Zone Diameter Value</Trans></Label>
                                                    <Input
                                                        name="initZoneDiameterValue"
                                                        value={initZoneDiameterValue}
                                                        className="form-control"
                                                        placeholder="Enter Value"
                                                        type="number"
                                                        required
                                                        onChange={(e) => setInitZoneDiameterValue(e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-6 mt-2">
                                                    <Label className="form-label"><Trans>Initial Zone Diameter Unit</Trans></Label>
                                                    <Input
                                                        name="initZoneDiameterUnit"
                                                        value={initZoneDiameterUnit}
                                                        className="form-control"
                                                        placeholder="Enter Unit"
                                                        type="text"
                                                        onChange={(e) => setInitZoneDiameterUnit(e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-6 mt-2">
                                                    <Label className="form-label"><Trans>Zone Diameter Increment Value</Trans></Label>
                                                    <Input
                                                        name="zoneDiameterIncrementValue"
                                                        value={zoneDiameterIncrementValue}
                                                        className="form-control"
                                                        placeholder="Enter Value"
                                                        type="number"
                                                        required
                                                        onChange={(e) => setZoneDiameterIncrementValue(e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-6 mt-2">
                                                    <Label className="form-label"><Trans>Zone Diameter Increment Unit</Trans></Label>
                                                    <Input
                                                        name="zoneDiameterIncrementUnit"
                                                        value={zoneDiameterIncrementUnit}
                                                        className="form-control"
                                                        placeholder="Enter Unit"
                                                        type="text"
                                                        onChange={(e) => setZoneDiameterIncrementUnit(e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-6 mt-2">
                                                    <Label className="form-label"><Trans>Max Zone Diameter Value</Trans></Label>
                                                    <Input
                                                        name="maxZoneDiameterValue"
                                                        value={maxZoneDiameterValue}
                                                        className="form-control"
                                                        placeholder="Enter Value"
                                                        type="number"
                                                        required
                                                        onChange={(e) => setMaxZoneDiameterValue(e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-6 mt-2">
                                                    <Label className="form-label"><Trans>Max Zone Diameter Unit</Trans></Label>
                                                    <Input
                                                        name="maxZoneDiameterUnit"
                                                        value={maxZoneDiameterUnit}
                                                        className="form-control"
                                                        placeholder="Enter Unit"
                                                        type="text"
                                                        onChange={(e) => setmaxZoneDiameterUnit(e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-6 mt-2">
                                                    <Label className="form-label"><Trans>Max Assigning Time</Trans></Label>
                                                    <Input
                                                        name="maxAssigningTime"
                                                        value={maxAssigningTime}
                                                        className="form-control"
                                                        placeholder="Enter Unit"
                                                        type="number"
                                                        required
                                                        onChange={(e) => setMaxAssigningTime(e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-3 mt-2">
                                                        <Label className="form-label"><Trans>Instant assign</Trans></Label>
                                                        <FormGroup switch>
                                                        <Input
                                                            type="switch"
                                                            size="md"
                                                            checked={instantAssign}
                                                            onClick={() => {
                                                                setInstantAssign(instantAssign == 1 ? 0 : 1);
                                                            }}
                                                            />
                                                        </FormGroup>
                                                </div>
                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ExpressDeliverySettings
